export default __webpack_public_path__ + "static/media/ic-chapter-test.697f76b5.svg";